import { getDocumentMeta } from "utils/getDocumentMeta";

export const areDebugRoutesEnabled = (): boolean => {
  return getDocumentMeta("enable_debug_routes") === "1";
};
